import React, { useLayoutEffect, useRef, useState } from 'react';
import { DrawnMark } from '@ofself/shell';
import { DEVELOPER_SVG, developerFigure } from './marks/developer';

// THE DEVELOPER MARK in the kit's drawing engine (DrawnMark), like every app's
// figure (Nucleus's is NucleusMark): drawn for its size (marks/developer.js).
//
// DRAWN FOR THE SIZE IT IS SHOWN AT, not the size it was asked for. The shell
// hands this one element to every seat — the rail's 34px tile and its larger
// tiles alike — so the figure is chosen from the box it actually fills: the
// heavy rail figure scaled up reads as blots, the whole figure is the clean one.
export default function DeveloperMark({ size = 34, title, className = '', ...rest }) {
  const ref = useRef(null);
  const [shown, setShown] = useState(size);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const measure = () => {
      const r = el.getBoundingClientRect();
      const px = Math.round(Math.min(r.width, r.height));
      if (px > 0) setShown(px);
    };
    measure();
    if (typeof ResizeObserver === 'undefined') return undefined;
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <span ref={ref} className={`dev-mark ${className}`} style={{ width: size, height: size, display: 'inline-block' }}
      role={title ? 'img' : undefined} aria-label={title || undefined} aria-hidden={title ? undefined : 'true'}>
      <DrawnMark svg={developerFigure(shown)} {...rest} />
    </span>
  );
}

// the splash's figure: the whole mark, the near bird drawn in before the far one
export function DeveloperSplashMark(props) {
  return <DrawnMark svg={DEVELOPER_SVG} {...props} />;
}
